import { AppData } from "@/src/constants/app-data";

export function StoryContent() {
    return (
        <section className="max-w-7xl mx-auto px-6 py-24 grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div className="space-y-6">
                <h2 className="font-serif text-4xl md:text-5xl font-light leading-tight">
                    Born from a love of <span className="italic">ritual</span>.
                </h2>
                <p className="text-stone-600 leading-relaxed font-light text-lg">
                    {AppData["AppName"]} was founded in 2019 in a small London
                    studio by Elena Hart, a perfumer who believed the home
                    deserved the same intentionality as a fine fragrance. What
                    began as a personal project became a pursuit: to create
                    candles that anchor the everyday.
                </p>
                <p className="text-stone-500 leading-relaxed font-light">
                    Every scent in our collection is developed in-house, drawing
                    on botanical raw materials sourced directly from growers
                    across Provence, Morocco, and Sri Lanka. We work in small
                    batches, never scaling beyond what our hands can touch.
                </p>
            </div>
            <div>
                <img
                    src="https://images.unsplash.com/photo-1544468266-6a8948003cd7?auto=format&fit=crop&q=80&w=1000"
                    alt="Our studio"
                    className="w-full aspect-square object-cover rounded-sm luxury-shadow"
                    referrerPolicy="no-referrer"
                />
            </div>
        </section>
    );
}
